import { render, staticRenderFns } from "./LoadTransaction.vue?vue&type=template&id=a104e5b4&lang=pug"
import script from "./LoadTransaction.vue?vue&type=script&lang=js"
export * from "./LoadTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports